import selectors from '../../../selectors/selectors.js';

const defaultServiceLocationSelector = (state) => {
  const locations = state.currentServiceProvider.locations;
  const activeServiceLocationId = (selectors.activeNonLeadMessage(state) || {}).service_location_id;
  if (!locations) {
    return undefined;
  }
  return locations.find((n) => n.id === activeServiceLocationId) || locations[0];
};

export default defaultServiceLocationSelector;
